"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCountry = exports.getCountry = exports.getCountriesFilter = exports.getCountryPaymentMethods = exports.getCountries = void 0;
const _ = require("lodash");
const getCountries = async (supabase) => {
    const { data: locations, error } = await supabase
        .from("countries")
        .select(`*,
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)
    , regions!inner(id)`)
        .order("name", { ascending: true });
    if (!error)
        return locations;
    return error;
};
exports.getCountries = getCountries;
const getCountryPaymentMethods = async (supabase, id) => {
    const { data: locations, error } = await supabase
        .from("payment_methods")
        .select(`*`)
        .eq("country_id", id);
    if (!error)
        return locations;
    return error;
};
exports.getCountryPaymentMethods = getCountryPaymentMethods;
const getCountriesFilter = async (supabase) => {
    const { data: locations, error } = await supabase
        .from("countries")
        .select(`id, name
    , regions!inner(id)`)
        .order("name", { ascending: true });
    if (!error)
        return locations;
    return error;
};
exports.getCountriesFilter = getCountriesFilter;
const getCountry = async (supabase, id) => {
    const { data: location, error } = await supabase
        .from("countries")
        .select(`*,
      payment_methods(*),
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return location;
    return error;
};
exports.getCountry = getCountry;
const updateCountry = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.payment_methods;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("countries")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateCountry = updateCountry;
